import React, { useState } from "react";
import DataTable, { DataTableQueryParams } from "../../../components/DataTable";
import CompanyRow from "./models/CompanyRow";
import companyColumns from "./util/companyColumns";
import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import SearchResponse from "../../../Models/APIGetData/SearchResponse";
import { CompanyUrls } from "../index";
import Company from "../../../Models/companies/Company";
import { isCBUser, isMegatronFeatureOn } from "../../../Authentication/Auth";

const CompanySearchTable = () => {
  const [megatronFeature, setMegatronFeature] = useState<boolean>(false);

  const maxFavouriteLimitFilter = {
    0: "0",
    100: "100",
    250: "250",
    1000: "1000",
  };

  var typeFilter={};
  if(isCBUser())
  {
        typeFilter = {
        Pro: "Pro"
      };
  }
  else
  {
        typeFilter = {
        Pro: "Pro",
        Lite: "Lite",
      };
  }

  const fetch = (
    params: DataTableQueryParams
  ): Promise<{ data: CompanyRow[]; totalPages: number }> =>
    axiosApi
      .get<SearchResponse<Company>>(
        `${BackendServices.COMPANY_SERVICE.COMPANY}/search`,
        { params }
      )
      .then(({ data }) => ({
        totalPages: data.totalPages,
        data: data.resultList.map(
          (company: Company): CompanyRow => ({
            id: company.id,
            name: company.name,
            city: company.location.city,
            country: company.location.country?.name ?? "",
            sites: company.siteCount,
            status: company.status,
            maxFavouriteLimit: company.maxFavouriteLimit,
            type: company.type,
            auditShared: company.auditShared,
          })
        ),
      }));

  const fetchMegatronFeatureOn = async () => {
    const getMegatronFeature = await isMegatronFeatureOn();
    setMegatronFeature(getMegatronFeature);
  };

  fetchMegatronFeatureOn();

  return (
    <DataTable<CompanyRow>
      columns={
        megatronFeature
          ? companyColumns
          : companyColumns.slice(0, companyColumns.length - 2)
      }
      fetchRemoteData={fetch}
      filters={{
        maxFavouriteLimit: () => maxFavouriteLimitFilter,
        type: () => typeFilter,
      }}
      toolBarOptions={{
        newEntityLink: !isCBUser()
          ? {
              label: "Add Company",
              link: CompanyUrls.create(),
            }
          : undefined,
      }}
      archiveFilter={{ enabled: true }}
    />
  );
};

export default CompanySearchTable;
